import { withValidation } from '@wix/editor-elements-corvid-utils';
import { CorvidTypes } from '@wix/editor-elements-types';
import { TpaGalleryCurrentItemSDK, TpaGalleryProps } from '../TPAGallery.types';

const _tpaGalleryCurrentItemSDKFactory: CorvidTypes.CorvidSDKFactory<
  TpaGalleryProps,
  TpaGalleryCurrentItemSDK
> = ({ registerEvent, props }) => {
  return {
    get currentIndex() {
      return props.currentIndex || 0;
    },
    onCurrentItemChanged(handler) {
      registerEvent('onCurrentItemChanged', handler);
    },
  };
};

export const tpaGalleryCurrentItemSDKFactory = withValidation(
  _tpaGalleryCurrentItemSDKFactory,
  {
    type: ['object'],
    properties: {
      onCurrentItemChanged: {
        type: ['function'],
        args: [{ type: ['function'] }],
      },
    },
  },
);
